module.exports = __webpack_public_path__ + "static/force-maintenance-vid-084aa0ae95b5b01816899cae3b0f4ee8.mp4";